module.exports = __webpack_public_path__ + "img/svg/result-winner-button-background.038dc6812f988f6a33a922ace455f57c.svg";